export default {"src":"/_next/static/media/allChains.99a4c68d.svg","height":18,"width":18};